import { forwardRef, type ReactNode } from "react";
import { cva, VariantProps } from "class-variance-authority";
import clsx from "clsx";

const typographyStyles = cva("", {
  variants: {
    variant: {
      title: "lg:text-3xl xl:text-4xl 2xl:text-6xl text-2xl font-semibold mb-0",
      titleLight: "lg:text-3xl xl:text-4xl 2xl:text-6xl text-2xl mb-0",
      heading2: "lg:text-2xl xl:text-3xl text-xl font-semibold",
      heading3: "lg:text-xl xl:text-2xl text-lg font-semibold",
      desc: "text-xs sm:text-sm md:text-base 2xl:text-lg text-secondary",
    },
  },
  defaultVariants: {
    variant: "desc",
  },
});

type TypographyProps = VariantProps<typeof typographyStyles> & {
  children: ReactNode;
  className?: string;
};

export const Typography = forwardRef<
  HTMLHeadingElement | HTMLParagraphElement,
  TypographyProps
>(({ variant = "desc", children, className = "", ...props }, ref) => {
  let Component: React.ElementType = "div";

  if (variant === "title") {
    Component = "h1";
  } else if (variant === "heading2") {
    Component = "h2";
  }
  return (
    <Component
      ref={ref}
      className={clsx(typographyStyles({ variant }), className)}
      {...props}
    >
      {typeof children === "string" ? (
        <div dangerouslySetInnerHTML={{ __html: children }} />
      ) : (
        children
      )}
    </Component>
  );
});

Typography.displayName = "Typography";
